import { useCallback, useState } from 'react'

import { getPercentageValue, isNumberValueValid } from 'features/views/attributes/editable/utils'

import useDebounce from 'v2/ui/utils/useDebounce'

const DEBOUNCE_TIME = 300 //ms

type UseSectionPercentageAttributeEditorStateProps = {
    value?: number
    onChange: (value: number) => void
}

export function useSectionPercentageAttributeEditorState({
    value,
    onChange,
}: UseSectionPercentageAttributeEditorStateProps) {
    let valueFromAttribute: string
    if (typeof value === 'number') {
        valueFromAttribute = (value * 100.0).toString()
    } else {
        valueFromAttribute = value ?? ''
    }

    const [localValue, setLocalValue] = useState(valueFromAttribute)
    const debouncedOnChange = useDebounce(onChange, DEBOUNCE_TIME)

    const handleChange = useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            const newValue = e.target.value

            const isValid = isNumberValueValid(newValue)
            if (!isValid) return

            setLocalValue(newValue)

            const targetValue = getPercentageValue(newValue)
            debouncedOnChange(targetValue)
        },
        [debouncedOnChange]
    )

    return {
        localValue,
        handleChange,
    }
}
